module.exports = __webpack_public_path__ + "img/horizontal_6_3_5012.2a737afc.png";